/** @jsx jsx */
import { jsx } from 'theme-ui'

import HeroCard from '@uswitch/ev-components/lib/components/compounds/hero-card/hero-card'
import { useEntity } from '@h/use-entity'
import { cf2imgix } from '@h/imgix-image'
import { EVEntry } from '@uswitch/ev-core/react'

const HeroCardCompound = (props: any) => {
  const image = useEntity(props.bgImage)

  return (
    <HeroCard
      type={props.type}
      title={props.title}
      ctaText={props.ctaText}
      ctaLink={props.ctaLink}
      bgImage={cf2imgix(image?.file?.url)}
    >
      {props?.links.map((entity: any, i: number) => {
        return <EVEntry {...entity} key={i} />
      })}
    </HeroCard>
  )
}

export default HeroCardCompound
